import cn from "@/util/cn";

const GRADIENT_BASE =
  "before:pointer-events-none before:absolute before:inset-y-0 before:right-full before:w-12 before:bg-linear-to-l before:to-transparent before:content-['']";
const GRADIENT_WHITE = `${GRADIENT_BASE} before:from-white`;
const GRADIENT_GRAY = `${GRADIENT_BASE} before:from-gray-50`;

export const stickyDataCell = ({
  rightClass,
  rowIndex,
  withGradient = false,
}: {
  rightClass: string;
  rowIndex: number;
  withGradient?: boolean;
}) => {
  const isEven = rowIndex % 2 === 0;
  return cn(
    "sticky z-10 pe-4",
    rightClass,
    isEven ? "bg-gray-50" : "bg-white",
    withGradient && (isEven ? GRADIENT_GRAY : GRADIENT_WHITE)
  );
};

export const stickyHeaderCell = ({
  rightClass,
  withGradient = false,
}: {
  rightClass: string;
  withGradient?: boolean;
}) => cn("sticky z-10 bg-white pe-4", rightClass, withGradient && GRADIENT_WHITE);
